import { createRowCellContentInner } from "../../../../common/table";
import { EntityFormViewTable } from "../../../../common/entity-form";
import React, { FC, useCallback, useMemo, useState } from "react";
import { useIntl } from "react-intl";
// import { IconButton } from "@mui/material";
// import { TrashIcon } from "../../../../common/icons";
import { SearchHelpInput } from "../../../../common/form-controls";
import SearchHelpDialog from "../../../../common/search-helps";
import { getRiskEmployeeSearchHelp, getCompensationProceduresSearchHelp, getCompensatedRisksSearchHelp } from "../../../../../utils/searchHelps";
import { CompensateRisksDataItem } from "@/types/compensation-procedures";
import "./style.less";

const getErrorFromValidationErrors = (row, columnId) => {
    return row && row[`error_${columnId}`];
};

type CompensatedEmployeeViewTableProps = {
    disabled?: boolean;
    errorIndex?: number | null;
    risks: CompensateRisksDataItem[];
    editRisk: (row: CompensateRisksDataItem, field: string, value: string) => void;
    setErrorIndex: (number) => void;
};

const CompensatedEmployeeViewTable: FC<CompensatedEmployeeViewTableProps> = ({ disabled = false, risks, editRisk, errorIndex, setErrorIndex }) => {
    const intl = useIntl();
    const [rowAction, setRowAction] = useState<{ type: string; row: CompensateRisksDataItem; field: string } | null>(null);

    const columnTexts = useMemo(
        () => ({
            employeeId: intl.formatMessage({ id: "compensate-risks-dialog.table.user-id-column" }),
            riskId: intl.formatMessage({ id: "compensate-risks-dialog.table.risk-id-column" }),
            riskDescription: intl.formatMessage({ id: "matrix-headers-form-content.subtable-column.risks.description" }),
        }),
        [intl]
    );
    const columns = useMemo(
        () => [
            {
                id: "employeeId",
                title: columnTexts.employeeId,
                type: "search-help",
                filterable: true,
            },
            {
                id: "riskId",
                title: columnTexts.riskId,
                type: "search-help",
            },

            {
                id: "riskDescription",
                title: columnTexts.riskDescription,
                type: "text",
                width: "40%",
            },
            // {
            //     id: "delete",
            //     type: "delete",
            // },
        ],
        [columnTexts]
    );

    // const searchHelpColumns = {
    //     employeeId: [
    //         { id: "key", title: columnTexts.employeeId },
    //         { id: "text", title: columnTexts.description },
    //     ],
    //     riskId: [
    //         { id: "key", title: columnTexts.riskId },
    //         { id: "text", title: columnTexts.description },
    //     ],
    // };

    const getSearchHelpData = useCallback(
        (params, signal) => {
            switch (rowAction?.field) {
                case "employeeId":
                    return getRiskEmployeeSearchHelp(params, signal);
                case "procedureId":
                    return getCompensationProceduresSearchHelp(params, rowAction?.row?.riskId, signal);
                case "riskId":
                    return getCompensatedRisksSearchHelp(params, rowAction?.row?.employeeId, signal);
            }
        },
        [rowAction]
    );

    const createRowCellContent = useCallback(
        (row, column, selected, onSelect) => {
            switch (column.type) {
                // case "delete": {
                //     return (
                //         <IconButton disabled={disabled} onClick={() => deleteRisk(row.id)}>
                //             <TrashIcon />
                //         </IconButton>
                //     );
                // }
                case "search-help": {
                    const error = getErrorFromValidationErrors(row, column.id);

                    return (
                        <SearchHelpInput
                            key={row.id}
                            disabled={disabled}
                            error={error ? row[column.id] === error.value && error["type"] === "validation" : false}
                            errorMessage={error && error.message}
                            warning={error ? row[column.id] === error.value && error["type"] === "integration_warning" : false}
                            warningMessage={error && error.message}
                            showFormHelpers={false}
                            showInnerHelpers
                            value={row[column.id]}
                            fullWidth
                            onOpenSearchHelp={() => {
                                setRowAction({
                                    type: "search-help",
                                    row: row,
                                    field: column.id,
                                });
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                editRisk(row, column.id, value);
                            }}
                        />
                    );
                }

                default:
                    return createRowCellContentInner(row, column, selected, onSelect);
            }
        },
        [editRisk, disabled]
    );
    return (
        <>
            <EntityFormViewTable
                className="reduce-risks-dialog-table "
                rows={risks}
                columns={columns}
                createRowCellContent={createRowCellContent}
                toolbarActions={[]}
                virtualize={false}
                errorIndex={errorIndex as null}
                setErrorScroll={setErrorIndex}
                virtualizationProps={{}}
            />
            {rowAction?.type === "search-help" && (
                <SearchHelpDialog
                    title={columnTexts[rowAction.field]}
                    currentIds={[]}
                    defaultSearchString={rowAction.row[rowAction.field] || ""}
                    open={rowAction && rowAction.type === "search-help"}
                    readRows={getSearchHelpData}
                    // columns={searchHelpColumns[rowAction.field]}
                    selectOneRow={true}
                    onSubmit={(selectedRow) => {
                        editRisk(rowAction.row, rowAction.field, selectedRow.key);
                        setRowAction(null);
                    }}
                    onCancel={() => {
                        setRowAction(null);
                    }}
                />
            )}
        </>
    );
};

export default CompensatedEmployeeViewTable;
